var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogThreeComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.0312C11.5695 12.0312 12.0312 11.5695 12.0312 11C12.0312 10.4305 11.5695 9.96875 11 9.96875C10.4305 9.96875 9.96875 10.4305 9.96875 11C9.96875 11.5695 10.4305 12.0312 11 12.0312Z",
    fill: "#D1A97A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 12.0312C7.78829 12.0312 8.25 11.5695 8.25 11C8.25 10.4305 7.78829 9.96875 7.21875 9.96875C6.64921 9.96875 6.1875 10.4305 6.1875 11C6.1875 11.5695 6.64921 12.0312 7.21875 12.0312Z",
    fill: "#D1A97A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7812 12.0312C15.3508 12.0312 15.8125 11.5695 15.8125 11C15.8125 10.4305 15.3508 9.96875 14.7812 9.96875C14.2117 9.96875 13.75 10.4305 13.75 11C13.75 11.5695 14.2117 12.0312 14.7812 12.0312Z",
    fill: "#D1A97A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8682 18.1423C8.60116 19.1453 10.6397 19.4838 12.6038 19.0947C14.5679 18.7056 16.3235 17.6156 17.5433 16.0277C18.763 14.4398 19.3636 12.4626 19.2332 10.4646C19.1028 8.46654 18.2502 6.58415 16.8344 5.16833C15.4186 3.75252 13.5362 2.89991 11.5381 2.76949C9.54013 2.63906 7.56287 3.23971 5.97501 4.45945C4.38714 5.67919 3.29706 7.43477 2.90799 9.39887C2.51892 11.363 2.85743 13.4015 3.86039 15.1345L2.78531 18.3443C2.74491 18.4654 2.73905 18.5954 2.76838 18.7197C2.79771 18.844 2.86107 18.9576 2.95136 19.0479C3.04166 19.1382 3.15531 19.2016 3.27959 19.2309C3.40387 19.2602 3.53386 19.2544 3.655 19.214L6.8682 18.1423Z",
    stroke: "#D1A97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogThreeComment);
export default __webpack_public_path__ + "static/media/blog-three-comment.198d6858c7ebf822525af4f60608b556.svg";
export { ForwardRef as ReactComponent };